<div class="carousel-container" *ngIf="showPopup">
    <div class="carousel-close-button" style="display: flex; flex-direction: row; gap: 10px">

        <button class="image-close-button" (click)="closePreview()">
            <mat-icon style="font-size: 20px">cancel</mat-icon>
        </button>
    </div>
    <div class="carousel">
        <button class="carousel-control prev" (click)="prevSlide()">
            &#10094;
        </button>

        <div class="carousel-image-container">

            
      <ng-container *ngIf="previewDocs.length == 0">
        <div class="alert alert-danger"> No Attachments.</div>
      </ng-container>

      <ng-container *ngIf="previewDocs.length > 0">
        <div class="headerattachmentcarouselimageContainerInner" *ngIf="isPdf(previewDocs[currentIndex]?.dataUrl)">
            <pdf-viewer [src]="previewDocs[currentIndex]?.dataUrl" [render-text]="false" [page]="1"
                [show-all]="true" [original-size]="false" class="content">
            </pdf-viewer>
        </div>
        <div class="headerattachmentimage-container-inner" *ngIf="!isPdf(previewDocs[currentIndex]?.dataUrl)">
            <img [src]="previewDocs[currentIndex]?.dataUrl" [alt]="'dispatch-image'" class="carousel-image" />
        </div>
      </ng-container>


        </div>

        <button class="carousel-control next" (click)="nextSlide()">
            &#10095;
        </button>
    </div>
</div>
